import { useFetch } from "@/lib/shieldx";
import { PageHeader, Loader } from "@/components/shieldx/Primitives";
import { StatusBadge, DemoTag } from "@/components/shieldx/Badges";
import { Table } from "@/components/shieldx/Table";
import { Building2 } from "lucide-react";

export default function Organizations() {
  const { data, loading } = useFetch("/organizations");
  if (loading || !data) return <Loader label="Loading organizations" />;

  const columns = [
    { key: "name", label: "Organization", render: (r) => (
      <div><p className="font-medium text-slate-100">{r.name}</p><p className="font-mono text-[11px] text-slate-500">{r.website || "—"}</p></div>
    ) },
    { key: "type", label: "Type" },
    { key: "country", label: "Country" },
    { key: "tier", label: "Tier", render: (r) => <span className="font-mono text-xs text-slate-400">{r.tier}</span> },
    { key: "security_score", label: "Score", render: (r) => <span className="font-mono tabular-nums text-slate-200">{r.security_score}</span> },
    { key: "mfa_required", label: "MFA", render: (r) => <span className={r.mfa_required ? "text-emerald-400" : "text-slate-500"}>{r.mfa_required ? "Enforced" : "Optional"}</span> },
    { key: "protection_status", label: "Status", render: (r) => <StatusBadge value={r.protection_status} /> },
  ];

  return (
    <div>
      <PageHeader icon={Building2} title="Organizations"
        subtitle="Multi-tenant hierarchy. Every organization's data remains isolated." actions={<DemoTag />} />
      <Table columns={columns} rows={data} testid="organizations-table" />
    </div>
  );
}
